import { Backbone } from "js/vendor";
import { PresentationFilters, SlideLockType } from "common/constants";

export class EditorLock extends Backbone.Model {
    defaults() {
        return {
            lockState: {
                [SlideLockType.OBSOLETE_TEMPLATE]: false,
                [SlideLockType.ORG]: false,
                [SlideLockType.TEAM_MEMBER]: false,
                [SlideLockType.COLLABORATION]: false
            },
            level: 0
        };
    }

    resetLockState() {
        this.set(this.defaults());
    }

    checkIfOnlyLockActive(type) {
        return this.attributes.lockState[type] &&
            Object.values(this.attributes.lockState).filter(lock => lock).length === 1;
    }

    setLockLevel(type, shouldLock) {
        let level = 0;
        if (shouldLock) {
            switch (type) {
                case SlideLockType.COLLABORATION:
                    level = 4;
                    break;
                case SlideLockType.ORG:
                    level = 3;
                    break;
                case SlideLockType.TEAM_MEMBER:
                    level = 2;
                    break;
                case SlideLockType.OBSOLETE_TEMPLATE:
                    level = 1;
                    break;
            }
            if (level > this.attributes.level) {
                this.set({
                    level
                });
            }
        } else {
            //reduce the level to 0 only if a higher priority lock is not set otherwise set the level to the next highest priority
            if (this.attributes.lockState[SlideLockType.COLLABORATION]) {
                level = 4;
            } else if (this.attributes.lockState[SlideLockType.ORG]) {
                level = 3;
            } else if (this.attributes.lockState[SlideLockType.TEAM_MEMBER]) {
                level = 2;
            } else if (this.attributes.lockState[SlideLockType.OBSOLETE_TEMPLATE]) {
                level = 1;
            }

            this.set({
                level
            });
        }
    }

    setLockState(type, shouldLock, options) {
        const updates = {};
        if (type) {
            if (!Object.values(SlideLockType).includes(type)) {
                throw new Error(`Unexpected: "type" with slide lock of type ${type}`);
            }
            updates[type] = shouldLock;
        } else {
            Object.values(SlideLockType).forEach(type => {
                updates[type] = shouldLock;
            });
        }

        this.set({
            lockState: {
                ...this.attributes.lockState,
                ...updates
            }
        }, options);

        this.setLockLevel(type, shouldLock);
    }
}

